import type { ThemeOptions } from '@mui/material';

const ListItemButtonTheme: ThemeOptions['components'] = {
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 6,
      },
    },
  },
};

export default ListItemButtonTheme;
